import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { options, references } from '@apexdesigner/schema-tools';

export const loginSession = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    sessionIdHash: z
      .string()
      .nullable()
      .optional()
      .hidden()
      .describe(
        'Session Id Hash - SHA-256 of the high-entropy session id in the login and done URLs',
      ),

    status: options([
      {
        value: 'Pending',
        name: 'Pending',
        description: 'Waiting for browser approval',
      },
      {
        value: 'Approved',
        name: 'Approved',
        description: 'Approved in the browser; token not yet collected',
      },
      {
        value: 'Collected',
        name: 'Collected',
        description: 'Token minted and delivered to the npm CLI',
      },
      {
        value: 'Expired',
        name: 'Expired',
        description: 'Approval window elapsed',
      },
    ])
      .nullable()
      .optional()
      .describe(
        'Status - Pending until approved in the browser, Collected once npm picks up the token',
      ),

    requestedLabel: z
      .string()
      .nullable()
      .optional()
      .describe(
        'Requested Label - Token label, editable on the authorize page',
      ),

    requestedCanPublish: z
      .boolean()
      .nullable()
      .optional()
      .describe(
        'Requested Can Publish - Approved publish flag, only honored for publisher-role users',
      ),

    expiresAt: z.coerce
      .date()
      .nullable()
      .optional()
      .describe(
        'Expires At - Bounds the browser-approval window, about five minutes',
      ),

    userId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to User'),

    tokenId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to RegistryToken'),

    user: references('User'),

    token: references('RegistryToken'),
  })
  .describe('The short-lived handshake record backing the npm login web flow.')
  .as('LoginSession');

export { loginSession as loginSessionSchema };
